import {ValidatorFn} from '@angular/forms';

import {ComponentTypesEnum} from '../../enums';
import {BaseControlInterface} from '../../interfaces';

import {Helper} from '../common/helper';

export class BaseControl<ValueType = string | number> {
    private readonly initialValue: ValueType;

    public name: string;
    public value: ValueType;
    public placeholder: string;
    public validators: ValidatorFn[];
    public componentType: ComponentTypesEnum;
    public errors: string[];
    public invalid: boolean;
    public disabled: boolean;
    public removable: boolean;
    public readonly: boolean;
    public hidden: boolean;
    public upperCaseValue: boolean;
    public floatingLabelNever: boolean;
    public sortIndex: number;

    public more: { [key: string]: any };

    constructor(data: BaseControlInterface<ValueType>) {
        this.name = data.name;
        this.value = data.value;
        this.validators = data.validators;
        this.placeholder = !data.nonCapitalizedPlaceholder ? Helper.getCapitalized(data.placeholder) : data.placeholder;
        this.componentType = data.componentType;
        this.errors = !data.errors ? [] : data.errors;
        this.invalid = !data.invalid ? false : data.invalid;
        this.disabled = !data.disabled ? false : data.disabled;
        this.removable = data.removable;
        this.readonly = data.readonly;
        this.hidden = data.hidden;
        this.upperCaseValue = !data.upperCaseValue ? false : data.upperCaseValue;
        this.floatingLabelNever = data.floatingLabelNever;
        this.more = !data.more ? {} : data.more;
        this.sortIndex = !data.sortIndex ? null : data.sortIndex;

        this.initialValue = data.value;
    }

    resetValue(setToNull: boolean = true): void {
        if (!setToNull) {
            this.value = this.initialValue;
        } else {
            this.value = null;
        }
    }

    resetValidators(): void {
        this.validators = [];
    }

    setValidators(validators: ValidatorFn[]): void {
        this.validators = validators;
    }

    extendValidators(validator: ValidatorFn) {
        this.validators.push(validator);
    }

    setError(error: string): void {
        if (this.errors.indexOf(error) < 0) {
            this.errors.push(error);
        }
    }

    removeError(error: string): void {
        const index = this.errors.indexOf(error, 0);
        if (index > -1) {
            this.errors.splice(index, 1);
        }
    }

    setErrors(errors: string[]): void {
        this.errors = errors;
    }

    resetErrors(): void {
        this.errors = [];
    }

    setHidden(hidden: boolean): void {
        this.hidden = hidden;
    }
}
